let initialState = null;

function support(state = initialState, action) {
    if (action.type === "SEND_SUPPORT_FORMULAR") {
      return action.res;
    } else if (action.type === "SUPPORT_RESET") {
        return action.res;
    }
    else {
    return state;
  }
}

export default support;
